import { useContext } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";

const WorkspaceLayout = () => {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  if (!workspaceId) {
    const firstWorkspace = user?.workspaceIds?.[0]?.uuid;
    if (firstWorkspace) {
      navigate(`/${firstWorkspace}`);
    } else {
      navigate("/workspace-dashboard", { replace: true });
    }
  }

  return (
    <>
      {/* Workspace-aware navbar/sidebar can go here */}
      <Outlet />
    </>
  );
};

export default WorkspaceLayout;
